import { createSlice } from "@reduxjs/toolkit";
import { errorHandler } from "../../../helpers/errorHandler";
import {
    Call,
    CallWithFormDataFile,
    downloadBlob,
} from "../../../helpers/fetch";
import {
    startUILoading,
    stopUILoading,
} from "../../actions/administrador/ui/ui";

const initialState = {
    report: null,
};

export const AcademicRecordByCurriculum = createSlice({
    name: "AcademicRecordByCurriculum",
    initialState,
    reducers: {
        setReport: (state, action) => {
            state.report = action.payload;
        },
        clearReport: (state) => {
            state.report = initialState.report;
        },
    },
});

export const { setReport, clearReport } = AcademicRecordByCurriculum.actions;

export default AcademicRecordByCurriculum.reducer;

// Actions
export const startShow = ({ cycles, period, year }) => {
    return async (dispatch) => {
        dispatch(startUILoading());
        const params = new URLSearchParams();
        if (cycles) {
            params.set("cycles", `${cycles.year}-${cycles.sub_cycle}`);
            if (period) {
                params.set("period", period);
            }
        } else if (year) {
            params.set("cycles", year);
        }

        const resp = await Call(
            `operators/reports/academic-records/by/curriculum`,
            "GET",
            params
        );

        if (resp.success) {
            dispatch(setReport(resp.success));
        } else {
            errorHandler(resp);
        }
        dispatch(stopUILoading());
    };
};

export const startExportReport = ({ cycles, year, period }) => {
    return async (dispatch) => {
        dispatch(startUILoading());
        const params = new URLSearchParams();

        if (cycles) {
            params.set("cycles", `${cycles.year}-${cycles.sub_cycle}`);
            if (period) {
                params.set("period", period);
            }
        } else if (year) {
            params.set("cycles", year);
        }
        params.set("export", 1);

        const response = await CallWithFormDataFile(
            `operators/reports/academic-records/by/curriculum`,
            "GET",
            params.toString()
        );
        downloadBlob(response, "Reporte de inscripciones y reinscripciones");

        dispatch(stopUILoading());
    };
};
